import { useNavigate } from 'react-router-dom';
import { useCheckout } from '../../../../../context/CheckoutContext';
import { useScreenSize } from '../../../../../context/ScreenSizeContext';
import CreateDigitalBillDialog from './CreateDigitalBillDialog';
import { createMenuUrl } from '../../../../../utils/linkBuilder';
import { useLocation } from '../../../../../context/LocationContext';
import { useCartStore } from '../../../../../context/cart/CartStore';

const CreateBill = () => {
  const { location } = useLocation();
  const { setSidebarContent } = useCheckout();
  const { isPhone } = useScreenSize();
  const cartIsEmpty = useCartStore((state) => state.cart.orderLines.length < 1);
  const navigate = useNavigate();

  const onCreated = () => {
    setSidebarContent('CART');

    if (isPhone && cartIsEmpty) {
      navigate(createMenuUrl(location.locationId));
    }
  };

  return <CreateDigitalBillDialog onClose={() => setSidebarContent('SELECT_TABLE')} onCreated={onCreated} />;
};

export default CreateBill;
